module.exports = __webpack_public_path__ + "14four/static/media/remote.8d636f96.png";